import React from "react";
import "../css/Pages.css";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div className="page services-page">

      <h1 className="page-title">Our Services</h1>
     <p className="page-intro">
  At Foodies, we offer a wide range of services to make every dining experience unforgettable. 
  From dine-in to online delivery, catering, and exclusive seasonal menus, we make food an experience. 
  Our chefs use only the freshest ingredients to craft delicious meals that delight your taste buds, 
  while our friendly staff ensures every visit or order is seamless and enjoyable. 
  Whether it's a casual lunch, a family celebration, or a large event, Foodies brings quality, flavor, and care to every dish.
</p>


      <div className="services-grid">
        {/* Dine-In */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/461415/pexels-photo-461415.jpeg"
            alt="Dine-in"
          />
          <h3>Dine-In Experience</h3>
          <p>
            Relax in a cozy and welcoming atmosphere while enjoying dishes made with fresh, high-quality ingredients.
            Perfect for family gatherings, romantic evenings, or casual meetups with friends.
          </p>
        </div>

        {/* Takeaway */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/7362966/pexels-photo-7362966.jpeg"
            alt="Takeaway"
          />
          <h3>Takeaway</h3>
          <p>
            Short on time? Our quick takeaway service ensures you can enjoy your favorite dishes on the go.
            We guarantee freshness and perfect packaging for every order.
          </p>
        </div>

        {/* Catering */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/12766596/pexels-photo-12766596.jpeg"
            alt="Catering"
          />
          <h3>Catering for Events</h3>
          <p>
            Hosting a party, wedding, or corporate event? Our catering service delivers a wide variety of meals 
            customized to your event's needs. Impress your guests with gourmet flavors and beautiful presentation.
          </p>
        </div>

        {/* Online Delivery */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/4392996/pexels-photo-4392996.jpeg"
            alt="Online Delivery"
          />
          <h3>Online Delivery</h3>
          <p>
            Enjoy your favorite dishes from the comfort of your home. Fast, reliable, and piping hot. 
            Track your order in real-time and savor the taste without leaving your house.
          </p>
        </div>

        {/* Custom Menus */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/4350105/pexels-photo-4350105.jpeg"
            alt="Custom Menus"
          />
          <h3>Custom Menus</h3>
          <p>
            Looking for something unique? Our chefs create custom menus tailored to your taste preferences, 
            dietary requirements, and occasion.
          </p>
        </div>

        {/* Seasonal Specials */}
        <div className="service-card">
          <img
            src="https://images.unsplash.com/photo-1586190848861-99aa4a171e90"
            alt="Seasonal Specials"
          />
          <h3>Seasonal Specials</h3>
          <p>
            Celebrate every season with exclusive dishes crafted from the freshest seasonal ingredients. 
            Each menu brings a unique flavor experience.
          </p>
        </div>

        {/* Party Packages */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/11061254/pexels-photo-11061254.jpeg"
            alt="Party Packages"
          />
          <h3>Party Packages</h3>
          <p>
            Our party packages are perfect for birthdays, anniversaries, and gatherings. 
            Includes menu planning, food preparation, and delivery so you can enjoy the celebration.
          </p>
        </div>

        {/* Loyalty Program */}
        <div className="service-card">
          <img
            src="https://images.pexels.com/photos/1099680/pexels-photo-1099680.jpeg"
            alt="Loyalty Program"
          />
          <h3>Loyalty Packages</h3>
          <p>
            Join our loyalty program and earn rewards every time you order. 
            Get exclusive discounts, special offers, and early access to new menu items.
          </p>
        </div>
         <div className="service-card">
          <img
            src="https://images.pexels.com/photos/1109197/pexels-photo-1109197.jpeg"
            alt="Loyalty Program"
          />
          <h3>Chef Program</h3>
          <p>
            Join our loyalty program and earn rewards every time you order. 
            Get exclusive discounts, special offers, and early access to new menu items.
          </p>
        </div>
         <div className="service-card">
          <img
            src="https://images.pexels.com/photos/1482803/pexels-photo-1482803.jpeg"
            alt="Loyalty Program"
          />
          <h3>Customer Program</h3>
          <p>
            Join our loyalty program and earn rewards every time you order. 
            Get exclusive discounts, special offers, and early access to new menu items.
          </p>
        </div>
      </div>
      

      {/* CTA Banner */}
      <section className="cta-banner">
        <h2>Ready to Experience Foodies?</h2>
        <p>Contact us today to book your table, order online, or schedule catering for your next event.</p>
        <Link to="/contact">
          <button className="hero-btn">Get in Touch</button>
        </Link>
      </section>

    </div>
  );
};

export default Services;
